// extracted by mini-css-extract-plugin
export default {"productsList":"productsList_productsList__qmxMb"};